import { render, staticRenderFns } from "./ignorer.vue?vue&type=template&id=eb511050"
import script from "./ignorer.vue?vue&type=script&lang=js"
export * from "./ignorer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports